import React from 'react';
import { Typography } from '@material-ui/core';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { getContent } from '../../../services';

const StyledContainer = styled.div`
	padding: 4rem 0;
	text-align: center;
`;

const StyledWrapCard = styled.div`
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
	margin: 0 1rem;
`;

const StyledCard = styled(Link)`
	box-shadow: 0px 30px 50px rgba(0, 0, 0, 0.1);
	height: 200px;
	margin: 1rem;
	cursor: pointer;
	border-radius: 8px;
	overflow: hidden;
	position: relative;

	& img {
		transition: transform 0.5s, filter 0.5s ease-in-out;
		filter: blur(2px);
	}

	&:hover img {
		filter: blur(0);
		transform: scale(1.1);
	}
`;

const Disekitar = ({ isId }: any) => {
	const [disekitarState, setDisekitarState] = React.useState<any>([]);

	const fetchBerita = async () => {
		try {
			const res = await getContent(10, 10, 1);
			setDisekitarState(res.data.rows);
		} catch (err) {}
	};

	React.useEffect(() => {
		fetchBerita();
	}, []);

	return (
		<StyledContainer>
			<Typography color="primary" variant="h4" style={{ marginBottom: '2rem' }}>
				{isId ? 'Disekitar Kami' : 'Around Us'}
			</Typography>
			<StyledWrapCard>
				{disekitarState.map((row: any, i: any) => (
					<StyledCard
						key={i}
						to={{
							state: row,
							pathname: `/disekitar-kami/${isId ? row.title_id : row.title_en}`,
						}}
					>
						<img
							src={`${process.env.REACT_APP_URL}/images/${row.image}`}
							style={{ height: '100%' }}
							alt={row.image}
						/>
						<Typography
							style={{
								position: 'absolute',
								top: 0,
								right: 0,
								color: 'white',
								padding: '0 1rem',
								backgroundColor: 'rgba(0,0,0,.5)',
							}}
							variant="overline"
						>
							{isId ? row.title_id : row.title_en}
						</Typography>
					</StyledCard>
				))}
			</StyledWrapCard>
		</StyledContainer>
	);
};

export default Disekitar;
